<div class="sidenav2">
    <a class="link" routerLink="/about">About</a>
    <a class="link active" routerLink="/gallery">Gallery</a> 
      <div class="dropdown-container" >
       <a  class="link active" routerLink="/gallery">All</a>
       <a class="link"  routerLink="/gallery/artwork">Artworks</a>
       <a class="link" routerLink="/gallery/illustrations">Illustrations</a>
       <a class="link"  routerLink="/gallery/bookplates">Bookplates</a>
      </div>
    <a class="link" routerLink="/shop">Shop</a>
    <a class="link" routerLink="/contact">Contact</a>
  </div>